import CustomModalV2 from "../../shared/custom-modal-v2/custom-modal-v2";
import {useState} from "react";
import './squadflix-collection-form.scss';
import SwitchToggle from "../../shared/switch-toggle/switch-toggle";
import {SquadflixCollectionSummary} from "../../app/myProfileView/my-profile-subroutes/my-profile-lists/types";
import {SquadflixCollectionsApi} from "../../../apis/squadflix-collections/SquadflixCollectionsApi";

type Props = {
    open: boolean;
    setOpen: (open: boolean) => void;
    onCreate?: (collection: SquadflixCollectionSummary) => void;
}

const SquadflixCollectionForm = ({open, setOpen, onCreate}: Props) => {

    const [name, setName] = useState("");
    const [isPrivate, setIsPrivate] = useState<boolean>(true);
    const [loading, setLoading] = useState(false);

    const handleClose = (force = false) => {
        if (loading && !force) return;
        setOpen(false);
        setTimeout(() => {
            setName("");
            setIsPrivate(true);
        }, 300);
    }

    const handleSave = () => {
        setLoading(true);
        SquadflixCollectionsApi.createCollection({
            name: name.trim(),
            isPrivate,
        }).then((res: { success: boolean, collection: SquadflixCollectionSummary }) => {
            if (res.success && onCreate) {
                onCreate(res.collection);
            }
        }).finally(() => {
            setLoading(false);
            handleClose(true);
        });
    }

    return (
        <CustomModalV2
            title="Crear colección"
            open={open}
            onClose={handleClose}
            primaryButton={{
                text: "Guardar",
                onClick: handleSave,
                variant: "primary",
                disabled: name.trim() === "",
            }}
            secondaryButton={{
                text: "Cancelar",
                onClick: handleClose,
                variant: "secondary",
            }}>
            <div className="squadflix-collection-form-modal-content">
                <input value={name} onChange={e => setName(e.target.value)}
                       type="text" placeholder="Nombre de la colección"
                       className="squadflix-collection-form-modal-content__input"/>
                <div className="w-100 d-flex justify-content-center align-items-center mt-4">
                    <SwitchToggle
                        value={isPrivate}
                        setValue={setIsPrivate}
                        size="large"
                        onLabel={<span>Privada <i className="fa-solid fa-lock"></i></span>}
                        offLabel={<span><i className="fa-solid fa-users"></i> Pública</span>}
                    />
                </div>
                <div className="mt-1" style={{
                    textAlign: 'center',
                }}>
                    {isPrivate &&
                        <small className="text-muted">Solo tu podrás ver esta colección y su contenido</small>}
                    {!isPrivate &&
                        <small className="text-muted">La colección será visible para los demás usuarios</small>}
                </div>
            </div>
        </CustomModalV2>
    )
}

export default SquadflixCollectionForm;
